import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const buildLoginUrl = () => {
  const redirectUrl = window.location.origin + "/app";
  return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth
export const exchangeSession = (session_id, role) =>
  apiClient.post("/auth/session", { session_id, role });

export const fetchMe = () => apiClient.get("/auth/me");

export const updateMe = (patch) => apiClient.patch("/auth/me", patch);
// Onboarding email/phone verification
export const verifyEmailSend = () => apiClient.post("/auth/verify/email/send", {});
export const verifyEmailConfirm = (otp) => apiClient.post("/auth/verify/email/confirm", { otp });
export const verifyPhoneSend = (phone) => apiClient.post("/auth/verify/phone/send", { phone });
export const verifyPhoneConfirm = (otp) => apiClient.post("/auth/verify/phone/confirm", { otp });

export const logout = () => apiClient.post("/auth/logout");

export const signupEmail = (payload) => apiClient.post("/auth/signup", payload);

export const loginEmail = (payload) => apiClient.post("/auth/login", payload);
export const loginOtpSend = (email) => apiClient.post("/auth/login/otp/send", { email });
export const loginOtpVerify = (email, otp) => apiClient.post("/auth/login/otp/verify", { email, otp });

// Public "Book a demo" / contact — lands in the admin Contact forms tab
export const submitContact = (payload) => apiClient.post("/contact", payload);

export const forgotPassword = (email) => apiClient.post("/auth/forgot-password", { email });

export const resetPasswordWithOtp = (payload) => apiClient.post("/auth/reset-password", payload);

// Admin
export const adminOverview = () => apiClient.get("/admin/overview");
export const adminUsers = (q, role) => apiClient.get("/admin/users", { params: { q: q || undefined, role: role || undefined } });
export const adminSuspendUser = (user_id, suspended) => apiClient.patch(`/admin/users/${user_id}/suspend`, { suspended });
export const adminToggleAdmin = (user_id, is_admin) => apiClient.patch(`/admin/users/${user_id}/admin`, { is_admin });
export const adminCreateUser = (payload) => apiClient.post("/admin/users", payload);
export const adminUpdateUser = (user_id, patch) => apiClient.patch(`/admin/users/${user_id}`, patch);
export const adminResetPassword = (user_id, password) => apiClient.post(`/admin/users/${user_id}/reset-password`, { password });
export const adminDeleteUser = (user_id) => apiClient.delete(`/admin/users/${user_id}`);
export const adminCompanies = () => apiClient.get("/admin/companies");
export const adminVerifyCompany = (company_id, verified) => apiClient.patch(`/admin/companies/${company_id}/verify`, { verified });
export const adminCreateCompany = (payload) => apiClient.post("/admin/companies", payload);
export const adminUpdateCompany = (company_id, patch) => apiClient.patch(`/admin/companies/${company_id}`, patch);
export const adminDeleteCompany = (company_id, delete_owner = false) => apiClient.delete(`/admin/companies/${company_id}`, { params: { delete_owner } });
export const adminColleges = () => apiClient.get("/admin/colleges");
export const adminCreateCollege = (payload) => apiClient.post("/admin/colleges", payload);
export const adminUpdateCollege = (college_id, patch) => apiClient.patch(`/admin/colleges/${college_id}`, patch);
export const adminDeleteCollege = (college_id, delete_owner = false) => apiClient.delete(`/admin/colleges/${college_id}`, { params: { delete_owner } });
export const adminModuleCatalog = () => apiClient.get("/admin/colleges/modules");
export const adminCollegeTeam = (college_id) => apiClient.get(`/admin/colleges/${college_id}/team`);
export const adminCollegeTeamInvite = (college_id, payload) => apiClient.post(`/admin/colleges/${college_id}/team`, payload);
export const adminCollegeTeamRemove = (college_id, member_id) => apiClient.delete(`/admin/colleges/${college_id}/team/${member_id}`);
export const adminPricing = () => apiClient.get("/admin/pricing");
export const adminUpdatePlan = (kind, plan_id, patch) => apiClient.patch(`/admin/pricing/${kind}/plans/${plan_id}`, patch);
export const adminUpdateCreditPacks = (kind, credit_packs) => apiClient.put(`/admin/pricing/${kind}/credit-packs`, { credit_packs });
export const adminAgencies = () => apiClient.get("/admin/agencies");
export const adminCreateAgency = (payload) => apiClient.post("/admin/agencies", payload);
export const adminUpdateAgency = (agency_id, patch) => apiClient.patch(`/admin/agencies/${agency_id}`, patch);
export const adminDeleteAgency = (agency_id, delete_owner = false) => apiClient.delete(`/admin/agencies/${agency_id}`, { params: { delete_owner } });
export const adminWaitlist = () => apiClient.get("/admin/waitlist");
export const adminJobs = () => apiClient.get("/admin/jobs");
export const adminLeads = () => apiClient.get("/admin/leads");
export const adminContacts = () => apiClient.get("/admin/contacts");
export const adminAudit = () => apiClient.get("/admin/audit");
export const adminAiSpend = () => apiClient.get("/admin/ai-spend");
// Lead CRM (admin calling desk)
export const crmLeads = (status, q) => apiClient.get("/admin/crm/leads", { params: { status: status || undefined, q: q || undefined } });
export const crmCreateLead = (payload) => apiClient.post("/admin/crm/leads", payload);
export const crmLeadDetail = (lead_id) => apiClient.get(`/admin/crm/leads/${lead_id}`);
export const crmPatchLead = (lead_id, patch) => apiClient.patch(`/admin/crm/leads/${lead_id}`, patch);
export const crmDeleteLead = (lead_id) => apiClient.delete(`/admin/crm/leads/${lead_id}`);
export const crmLogActivity = (lead_id, payload) => apiClient.post(`/admin/crm/leads/${lead_id}/activities`, payload);
export const crmAddReminder = (lead_id, payload) => apiClient.post(`/admin/crm/leads/${lead_id}/reminders`, payload);
export const crmPatchReminder = (reminder_id, status) => apiClient.patch(`/admin/crm/reminders/${reminder_id}`, { status });
export const crmDueReminders = () => apiClient.get("/admin/crm/reminders/due");
export const adminIntegrations = () => apiClient.get("/admin/integrations");
export const adminSaveIntegrations = (updates) => apiClient.put("/admin/integrations", { updates });
export const adminTestIntegration = (service) => apiClient.post(`/admin/integrations/test/${service}`);

// Resume
export const uploadResume = (file, targetRole) => {
  const form = new FormData();
  form.append("file", file);
  if (targetRole) form.append("target_role", targetRole);
  return apiClient.post("/resume/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const latestResume = () => apiClient.get("/resume/latest");

// Coach
export const coachSend = (message, session_id) =>
  apiClient.post("/coach/chat", { message, session_id });

export const coachHistory = () => apiClient.get("/coach/history");
export const coachJourney = () => apiClient.get("/coach/journey");
// Company Prep Hub
export const companiesList = () => apiClient.get("/companies");
export const companyDetail = (slug) => apiClient.get(`/companies/${slug}`);
export const updateMyEligibility = (patch) => apiClient.patch("/auth/me", patch);
export const adminRecruiters = () => apiClient.get("/admin/recruiters");
export const adminUpsertRecruiter = (slug, payload) => apiClient.put(`/admin/recruiters/${slug}`, payload);
export const adminDeleteRecruiter = (slug) => apiClient.delete(`/admin/recruiters/${slug}`);
export const adminRegenerateRecruiter = (slug) => apiClient.post(`/admin/recruiters/${slug}/regenerate`);

// Interview
export const vapiConfig = () => apiClient.get("/interview/vapi-config");

export const saveInterview = (payload) =>
  apiClient.post("/interview/save", payload);

export const latestInterview = () => apiClient.get("/interview/latest");

export const interviewHistory = () => apiClient.get("/interview/history");

// Composite
export const compositeScore = () => apiClient.get("/score/composite");

export const scoreHistory = () => apiClient.get("/score/history");
export const getCoachingPlan = (refresh = false) =>
  apiClient.get("/coaching/plan", { params: refresh ? { refresh: true } : {} });
export const skillGap = () => apiClient.get("/skills/gap");
export const skillGapRefresh = () => apiClient.post("/skills/gap/refresh");
export const getBadges = () => apiClient.get("/badges");
export const learningResources = () => apiClient.get("/learn/resources");
export const techRoadmap = () => apiClient.get("/roadmap");
export const toggleRoadmapTopic = (topic_id) => apiClient.post(`/roadmap/topics/${topic_id}/toggle`);
export const regenerateRoadmap = () => apiClient.post("/roadmap/regenerate");
export const companyTests = () => apiClient.get("/company-tests");
// Company mocks are drive-gated: pass the campus drive_id (string or {drive_id}).
export const companyTestStart = (arg) =>
  apiClient.post("/company-tests/start", typeof arg === "string" ? { drive_id: arg } : arg);
export const driveCompanyBrief = (driveId) => apiClient.get(`/campus/my/drives/${driveId}/company`);
// College review flow — the cell approves the brief before students see it.
export const cellCompanyBrief = (driveId) => apiClient.get(`/campus/drives/${driveId}/company`);
export const cellApproveBrief = (driveId, approved) =>
  apiClient.post(`/campus/drives/${driveId}/company/${approved ? "approve" : "unapprove"}`);
export const companyTestSubmit = (test_id, payload) => apiClient.post(`/company-tests/${test_id}/submit`, payload);
export const interviewVapiConfig = (mode = "general", role = "") =>
  apiClient.get(`/interview/vapi-config?mode=${mode}&role=${encodeURIComponent(role)}`);

// WishAgent — auto-apply
export const wishagentStatus = () => apiClient.get("/wishagent/status");
export const wishagentSubscribe = () => apiClient.post("/wishagent/subscribe");
export const wishagentProfile = () => apiClient.get("/wishagent/profile");
export const wishagentSaveProfile = (payload) => apiClient.put("/wishagent/profile", payload);
export const wishagentSaveResume = (payload) => apiClient.put("/wishagent/profile/resume", payload);
export const wishagentSavePrefs = (payload) => apiClient.put("/wishagent/prefs", payload);
export const wishagentRun = () => apiClient.post("/wishagent/run");
export const wishagentApplications = () => apiClient.get("/wishagent/applications");
export const wishagentApprove = (id) => apiClient.post(`/wishagent/applications/${id}/approve`);
export const wishagentDismiss = (id) => apiClient.post(`/wishagent/applications/${id}/dismiss`);

// Practice pack (freemium) + proctored mock tests
export const practiceAllowance = () => apiClient.get("/practice/allowance");
export const purchasePracticePack = () => apiClient.post("/practice/purchase");
export const mockTestStart = (role) => apiClient.post("/mocktest/start", role ? { role } : {});
export const mockTestSubmit = (id, payload) => apiClient.post(`/mocktest/${id}/submit`, payload);
export const mockTestHistory = () => apiClient.get("/mocktest/history");

export const getInterview = (id) => apiClient.get(`/interview/${id}`);
export const linkedinCoach = (section, current_content) =>
  apiClient.post("/linkedin/coach", { section, current_content });
export const salaryBenchmark = () => apiClient.get("/salary/benchmark");
export const buildResume = (experience_text, target_role) =>
  apiClient.post("/resume/build", { experience_text, target_role });
// Guided "build on the platform" form → structured details (fresher-friendly).
export const buildResumeFromDetails = (details, target_role) =>
  apiClient.post("/resume/build", { details, target_role });
// Find my fit — guided role discovery for freshers.
export const coachFitQuestions = () => apiClient.get("/coach/fit/questions");
export const coachFitRun = (answers) => apiClient.post("/coach/fit", { answers });
export const coachFitChoose = (role) => apiClient.post("/coach/fit/choose", { role });
// Courses: one ranked list over college + Wishire courses; required ones until done.
export const coursesMine = () => apiClient.get("/courses/mine");
export const coursesRecommended = (limit = 3) => apiClient.get(`/courses/recommended?limit=${limit}`);
export const setCourseStatus = (course_id, status) => apiClient.post(`/courses/${course_id}/status`, { status });
export const adminCourses = () => apiClient.get("/admin/courses");
export const adminCreateCourse = (payload) => apiClient.post("/admin/courses", payload);
export const adminUpdateCourse = (id, payload) => apiClient.put(`/admin/courses/${id}`, payload);
export const adminDeleteCourse = (id) => apiClient.delete(`/admin/courses/${id}`);
export const adminCourseProgress = (id, college_id) => apiClient.get(`/admin/courses/${id}/progress${college_id ? `?college_id=${encodeURIComponent(college_id)}` : ""}`);
export const adminCoursesDashboard = () => apiClient.get("/admin/courses/dashboard");
// Course player
export const courseDetail = (id) => apiClient.get(`/courses/${id}`);
export const lessonComplete = (id, lesson_id) => apiClient.post(`/courses/${id}/lessons/${lesson_id}/complete`);
export const lessonQuiz = (id, lesson_id, answers) => apiClient.post(`/courses/${id}/lessons/${lesson_id}/quiz`, { answers });
export const lessonPosition = (id, lesson_id, seconds) => apiClient.post(`/courses/${id}/lessons/${lesson_id}/position`, { seconds });
export const courseReview = (id, rating, text) => apiClient.post(`/courses/${id}/review`, { rating, text });
export const courseCertificateUrl = (id) => `${apiClient.defaults.baseURL}/courses/${id}/certificate`;
export const verifyCertificate = (cert_id) => apiClient.get(`/certificates/${cert_id}`);
export const certificateImageUrl = (cert_id) => `${apiClient.defaults.baseURL}/certificates/${cert_id}/image`;
// Certificate templates (admin)
export const adminCertTemplates = () => apiClient.get("/admin/certificates/templates");
export const adminCreateCertTemplate = (payload) => apiClient.post("/admin/certificates/templates", payload);
export const adminUpdateCertTemplate = (id, payload) => apiClient.put(`/admin/certificates/templates/${id}`, payload);
export const adminDeleteCertTemplate = (id) => apiClient.delete(`/admin/certificates/templates/${id}`);
export const adminCertTemplatePreviewUrl = (id, source = "college") => `${apiClient.defaults.baseURL}/admin/certificates/templates/${id}/preview.png?source=${source}`;
export const adminCertTemplateDraftPreview = (payload, source = "college") => apiClient.post(`/admin/certificates/templates/preview.png?source=${source}`, payload, { responseType: "arraybuffer" });
// Resume wizard: prefill from everything we know, then a short fact-gathering chat.
export const resumePrefill = () => apiClient.get("/resume/prefill");
export const atsCheck = (payload) => apiClient.post("/resume/ats-check", payload);
export const atsFix = (payload) => apiClient.post("/resume/ats-fix", payload);
export const resumeChat = (messages, details, topic_index) => apiClient.post("/resume/chat", { messages, details, topic_index });
// Resume-build paywall: first build free, then ₹resume_build_inr per build.
export const resumeEntitlement = () => apiClient.get("/resume/entitlement");
export const purchaseResumeBuild = () => apiClient.post("/resume/purchase");
export const practiceQuestions = (topic, difficulty, num = 5) =>
  apiClient.get(`/practice/questions?topic=${encodeURIComponent(topic)}&difficulty=${difficulty}&num=${num}`);
export const linkedinMyStatus = () => api.get("/api/linkedin/my-status");

export const generateDocx = (structured, template) =>
  apiClient.post("/resume/docx", { structured, template }, { responseType: "blob" });

// Rejection Coaching
export const getRejectionCoaching = (appId) => apiClient.get(`/app/coaching/rejection/${appId}`);
export const acknowledgeRejectionCoaching = (appId) => apiClient.post(`/app/coaching/rejection/${appId}/acknowledge`);

// Scorecards
export const getScorecardTemplates = () => apiClient.get('/company/scorecard-templates');
export const createScorecardTemplate = (data) => apiClient.post('/company/scorecard-templates', data);
export const submitScorecard = (interviewId, data) => apiClient.post(`/company/interviews/${interviewId}/scorecard`, data);
export const getInterviewScorecard = (interviewId) => apiClient.get(`/company/interviews/${interviewId}/scorecard`);
export const shareScorecard = (scorecardId) => apiClient.post(`/company/scorecards/${scorecardId}/share`);
export const getMyScorecards = () => apiClient.get('/app/my-scorecards');

// Score integrity (Sprint 2)
export const getScoreTier = () => apiClient.get('/app/score/tier');
export const getScoreHistory = () => apiClient.get('/app/score/history');
export const markScoreActivity = () => apiClient.post('/app/score/activity');
export const verifyIdentity = (data) => apiClient.post('/app/score/verify-identity', data);
export const getVerificationStatus = () => apiClient.get('/app/score/verification-status');

// Growth loop (Sprint 3)
export const getMatchedJobs = () => apiClient.get('/app/jobs/matched');
export const getApplicationTransparency = () => apiClient.get('/app/applications/transparency');
export const getMyApplications = () => apiClient.get('/applications/mine');
export const getUnreadMessages = () => apiClient.get('/messages/unread');
export const getReferralStats = () => apiClient.get('/app/referrals');
export const applyReferralCode = (code) => apiClient.post('/app/referrals/apply', { referral_code: code });
export const getCompanyAnalytics = () => apiClient.get('/company/analytics');
export const getScoreDistribution = () => apiClient.get('/company/analytics/score-distribution');

// Sales funnel (super admin)
export const salesProspects = () => apiClient.get("/admin/sales/prospects");
export const salesAddProspects = (prospects, enroll = true) => apiClient.post("/admin/sales/prospects", { prospects, enroll });
export const salesPatchProspect = (id, patch) => apiClient.patch(`/admin/sales/prospects/${id}`, patch);
export const salesDeleteProspect = (id) => apiClient.delete(`/admin/sales/prospects/${id}`);
export const salesPreviewNext = (id) => apiClient.get(`/admin/sales/prospects/${id}/preview`);
export const salesSendNext = (id) => apiClient.post(`/admin/sales/prospects/${id}/send-next`);
export const salesRunNow = () => apiClient.post("/admin/sales/run");
export const salesTemplates = () => apiClient.get("/admin/sales/templates");
export const salesSaveTemplates = (steps) => apiClient.put("/admin/sales/templates", { steps });
export const adminStudentPrices = () => apiClient.get("/admin/pricing/student");
export const adminSaveStudentPrices = (prices) => apiClient.put("/admin/pricing/student", { prices });
export const adminFeatureFlags = () => apiClient.get("/admin/features");
export const adminSaveFeatureFlags = (flags) => apiClient.put("/admin/features", { flags });
export const salesSaveDraft = (id, subject, body) => apiClient.post(`/admin/sales/prospects/${id}/draft`, { subject, body });
export const salesClearDraft = (id) => apiClient.delete(`/admin/sales/prospects/${id}/draft`);
export const salesBrochure = () => apiClient.get("/admin/sales/brochure");
export const salesPutBrochure = (payload) => apiClient.put("/admin/sales/brochure", payload);
export const salesDeleteBrochure = () => apiClient.delete("/admin/sales/brochure");
export const salesPatchBrochure = (attach_steps) => apiClient.patch("/admin/sales/brochure", { attach_steps });
export const salesResearch = (region, college_type = "engineering") => apiClient.post("/admin/sales/research", { region, college_type });
export const salesResearchLeads = () => apiClient.get("/admin/sales/research/leads");
export const salesAddLead = (id) => apiClient.post(`/admin/sales/research/leads/${id}/add`);
export const salesLeadToCrm = (id) => apiClient.post(`/admin/sales/research/leads/${id}/crm`);
export const salesDismissLead = (id) => apiClient.delete(`/admin/sales/research/leads/${id}`);
